export default class CamelCase {
  /**
   * @description
   * @returns {*}
   * @param string
   */
  toCamel(string) {
    return string.replace(/([-_][a-z])/gi, $1 => {
      return $1.toUpperCase().replace('-', '').replace('_', '')
    })
  }

  /**
   * @description
   * @returns {arg is any[]}
   * @private
   * @param arr
   */
  _isArray(arr) {
    return Array.isArray(arr)
  }

  /**
   * @description
   * @returns {boolean}
   * @param object
   */
  isObject(object) {
    return object === Object(object) && !this._isArray(object) && typeof object !== 'function'
  }

  /**
   * @description
   * @returns {{}|*}
   * @param object
   */
  keysToCamel(object) {
    if (this.isObject(object)) {
      const newObject = {}

      Object.keys(object).forEach(key => {
        newObject[this.toCamel(key)] = this.keysToCamel(object[key])
      })

      return newObject
    } else if (this._isArray(object)) {
      return object.map(i => {
        return this.keysToCamel(i)
      })
    }

    return object
  }
}
